import './App.css';
import Model from './components/Model';
import Navbar from './components/Navbar';

function App() {

  return (
    <div className="App">
      <Navbar/>
      <Model/>
    </div>
  );
}

export default App;
